import type { TApiFieldError, TConstraintViolation } from '../utilities/fetcher/api.types'

export interface ICause extends Record<string, unknown> {
  uri?: string
  errors?: TApiFieldError[] | TConstraintViolation[]
  originalError?: Error
}

export type TExceptionParams = {
  message?: string
  cause?: ICause
}

export abstract class Exception extends Error {
  public cause?: ICause
  constructor(props?: TExceptionParams) {
    super(props?.message, { cause: props?.cause })
    Object.setPrototypeOf(this, new.target.prototype)
    this.name = 'Exception'
    if (props?.cause) {
      this.cause = props.cause
    }
  }
}
